'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['award']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<section class=\"award\">\n    <a href=\"{{ award.link }}\">\n        <img :src=\"award.image\">\n    </a>\n    <h4 class=\"award__title title title--h4\">{{ award.title }}</h4>\n    <p class=\"award__position\">{{ award.position }}</p>\n    <p v-if=\"award.description\" class=\"award__description\">{{ award.description }}</p>\n    <div class=\"award__link-wrap\" v-if=\"award.show\">\n        <a v-if=\"award.project\" href=\"{{ award.project.url }}\" class=\"award__link link\">{{ award.project.post_title }}</a>\n    </div>\n</section>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-586541ce", module.exports)
  } else {
    hotAPI.update("_v-586541ce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}